const GE_LOGISTICA_GROUP = 'GeLogistica'
const DES_PROVEEDORES_GROUP = 'DesProveedores'
const COOR_PROV_GROUP = 'CoorProveeduria'
const COOR_ACO_GROUP = 'CoorCostos'
const JR_ACO_GROUP = 'ACoJr'
const SR_ACO_GROUP = 'ACoSr'
const SUPERVISOR_GROUP = 'Supervisor'
const CODI_GROUP = 'CoDi'
const GEOP_GROUP = 'GeOp'
const PROVIDER_GROUP = 'Proveedor'

const EXTRANET_GROUPS = [
  'extranet_CoDi',
  'extranet_GeOp',
  'extranet_Supervisor',
  'extranet_Cliente'
]

const SUPPLIERS_GROUPS = [
  'AuxClara',
  'AuxCxP',
  'AuxCompras',
  'Proveeduría',
  COOR_PROV_GROUP,
  DES_PROVEEDORES_GROUP,
  GE_LOGISTICA_GROUP
]

const SUPPLIER_GROUPS_LOW_TIER = [
  'AuxClara',
  'AuxCxP',
  'AuxCompras'
]

export { EXTRANET_GROUPS, SUPPLIERS_GROUPS, SUPPLIER_GROUPS_LOW_TIER, DES_PROVEEDORES_GROUP, GE_LOGISTICA_GROUP,
  COOR_ACO_GROUP, JR_ACO_GROUP, SR_ACO_GROUP, SUPERVISOR_GROUP, PROVIDER_GROUP, CODI_GROUP, GEOP_GROUP }
